/**
 * Note list-item formatting.
 *
 * Two pure helpers lifted out of `NotesViewer.tsx` (823 lines, 7 useEffect,
 * zero tests). They are the only logic in that file with no React dependency,
 * which makes them the part that can be extracted and tested without risking
 * the effect-timing changes that make the rest of it hazardous to touch.
 */
import { parseUtcDate } from '@/lib/datetime';

/** First 60 characters of a note's text, for the selector list. */
export function getNotePreview(content: string): string {
  // Tag-stripping by regex is deliberate and sufficient here: the input is
  // Quill's own output (a known, small tag set) and the result is a truncated
  // preview, never rendered as HTML. Do not reuse this to sanitise untrusted
  // markup — it is not an HTML parser.
  const text = content.replace(/<[^>]*>/g, '').trim();
  return text.length > 60
    ? text.substring(0, 60) + '...'
    : text || 'Empty note';
}

/** Short "Mar 4"-style date for the selector list. */
export function formatNoteDate(dateStr: string): string {
  // parseUtcDate, not `new Date`: the backend sends naive UTC timestamps and
  // the plain constructor would read them as local time, shifting the date by
  // up to a day either side of midnight.
  const d = parseUtcDate(dateStr);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
